/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_S2Inputs */

const en_mk_tut_agen_s2 = /** @type {(inputs: Mk_Tut_Agen_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Within seconds the status changes to **In progress** and a “working” marker appears next to the title.`)
};

const id_mk_tut_agen_s2 = /** @type {(inputs: Mk_Tut_Agen_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam beberapa detik status berubah menjadi **Dikerjakan** dan muncul penanda "sedang dikerjakan" di sebelah judul.`)
};

/**
* | output |
* | --- |
* | "Within seconds the status changes to **In progress** and a “working” marker appears next to the title." |
*
* @param {Mk_Tut_Agen_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_s2 = /** @type {((inputs?: Mk_Tut_Agen_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_s2(inputs)
	return en_mk_tut_agen_s2(inputs)
});